import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
var cordovaExec = function cordovaExec() {
  var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var fail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var pluginName = arguments.length > 2 ? arguments[2] : undefined;
  var methodName = arguments.length > 3 ? arguments[3] : undefined;
  var args = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  if (typeof cordova === 'undefined') return false;
  cordova.exec(success, fail, pluginName, methodName, args);
};
// window.setTheme =setTheme
export var eventListen = function eventListen(eventName, success, fail) {
  if (!window.EVENTS) window.EVENTS = [];
  if (!window.LYNKAPP) return;
  // 监听用户注册事件，兼容客户端多次触发$emit方法导致一个$on监听回调执行多次的bug
  window.LYNKAPP.$on('lynkEventCall', function (ret) {
    console.log(8888888);
    var eventData = ret.eventData; // 解析事件数据
    if (typeof eventData === 'string' && eventData) eventData = JSON.parse(eventData);
    if (eventName === ret.eventName) success({
      data: eventData
    });
  });
  if (window.EVENTS.join(',').indexOf(eventName) < 0) {
    cordovaExec(function () {}, fail, 'SWXEventPlugin', 'listen', [{
      eventName: eventName
    },
    // 参数对象args[0]
    {
      namespace: 'LYNKAPP',
      eventCall: 'lynkEventCall'
    } // 参数对象args[1]
    ]);
    window.EVENTS.push(eventName);
  }
};